// extracted by mini-css-extract-plugin
export default {"main":"Verify_main__ryBKS"};